window.UneekSso = {
  url: APP_PATH_PREFIX,
  UserSessions: {
    modalSelector: null,
    getTabsSelector: function () {
      return ".user-sessions-form .modal-header .nav-link";
    }
  }
};
